export const generateWelcomeToolsLinks = ({
  canAccessUltra,
  canAccessPro
}: {
  canAccessUltra: boolean;
  canAccessPro: boolean;
}) => {
  return [
    {
      header: 'My Team',
      description:
        'See gameweek predictions for your team, swap players, get AI transfer recommendations, and see all details about your mini league.',
      buttonText: 'Explore My Team',
      buttonLink: '/my-team/pick'
    },
    {
      header: 'OPTA Stats',
      description:
        'See all the key stats that you would need to make informed decisions about your team, all in one place.',
      buttonText: 'Explore OPTA Stats',
      buttonLink: '/opta'
    },
    {
      header: 'Points Predictions',
      description:
        'Get a good sense check of whether a player is a good asset for your team.',
      buttonText: 'Explore Points Predictions',
      buttonLink: '/predictions'
    },
    {
      header: 'Fixture Analyser',
      description: 'Analyse upcoming fixtures and plan for the future.',
      buttonText: 'Explore Fixture Analyser',
      buttonLink: '/fixture-ticker'
    },
    {
      header: 'Player Comparison',
      description:
        'Compare players & teams using heatmaps, charts and OPTA data.',
      buttonText: 'Explore Player Comparison',
      buttonLink: '/fpl-player-comparison-tool'
    },
    {
      header: `WhatsApp Communities`,
      description:
        'Chat all things Fantasy Football with other players. Help each other out and build a community of successful managers.',
      buttonText: canAccessPro ? 'Explore the Pro Group' : 'Upgrade for access',
      buttonLink: canAccessPro ? '/whatsapp' : '/member-upgrade',
      isLocked: !canAccessPro,
      isLockedText: 'Pro feature'
    },
    {
      header: `Secret Ultra WhatsApp Group`,
      description:
        'Ultra Club Secret WhatsApp community with Hub founder, Will Thomas and Ultra expert, Rich Clarke.',
      buttonText: canAccessUltra
        ? 'Explore the Ultra Group'
        : 'Upgrade for access',
      buttonLink: canAccessUltra ? '/whatsapp' : '/member-upgrade',
      isLocked: !canAccessUltra,
      isLockedText: 'Ultra feature'
    },
    {
      header: `Personalised Expert FPL Team Reviews`,
      description: canAccessUltra
        ? "Please email Rich Clarke (richard@fantasyfootballhub.co.uk) with a screenshot of your current team and he'll get back to you. Please include your FPL ID (1-7 digit number that appears in the URL when you click on 'view Gameweek history' on the main FPL site)."
        : 'Get your team reviewed by one of our experts.',
      buttonText: canAccessUltra ? '' : 'Upgrade for access',
      buttonLink: canAccessUltra ? '' : '/member-upgrade',
      isLocked: !canAccessUltra,
      isLockedText: 'Ultra feature'
    },
    {
      header: 'Download our app',
      description:
        'The home of fantasy football in your pocket. Same tools and content as on the website, easily accessible on the go.',
      buttonText: 'Download',
      buttonLink: 'https://onelink.to/ffhubapp',
      openInNewLink: true
    }
  ];
};

export const welcomePageArticleLinks = [
  {
    header: 'Gameweek Tips',
    description:
      'Our contributors feature content every Gameweek to prepare you for the fixtures ahead.',
    buttonText: 'Read Gameweek Tips',
    buttonLink: '/fantasy-premier-league-ultimate-guide-fpl-tips',
    imageName: 'gameweek-tips.png'
  },
  {
    header: 'Team Reveals',
    description:
      'Our FPL experts share their teams with you, so you can get inspired on how to create yours.',
    buttonText: 'Read Team Reveals',
    buttonLink: '/category/team-reveal',
    imageName: 'team-reveal.png'
  },
  {
    header: 'Latest FPL Articles',
    description:
      'Get general FPL articles on how to build the right squad to bring you victory in your Mini League.',
    buttonText: 'Read Latest Tips',
    buttonLink: '/category/fpl',
    imageName: 'latest-tips.png'
  }
];
